import { Injectable, signal } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';

export type DiceColor = 'ORANGE' | 'BLUE' | 'EMERALD';

@Injectable({
  providedIn: 'root',
})
export class DiceService {
  public readonly isRolling = signal(false);
  public readonly isNumericDiceAvailable = signal(false);

  private rollAnimationHandler: ((color: DiceColor, faces: string[] | undefined, result: number) => Promise<void>) | undefined;

  public registerAnimationHandler(fn: (color: DiceColor, faces: string[] | undefined, result: number) => Promise<void>): void {
    this.rollAnimationHandler = fn;
  }

  public async roll(color: DiceColor, faces?: string[], result?: number): Promise<number> {
    if (!this.rollAnimationHandler) {
      throw new Error('Dice animation handler not registered.');
    }

    this.isRolling.set(true);

    await delay(50);

    result ??= Math.floor(Math.random() * 6);
    await this.rollAnimationHandler(color, faces, result);

    await delay(500); // allow some time for the result to be seen before re-focusing

    this.isRolling.set(false);

    return result;
  }
}
